<template>
  <div class="noImg">
    <div><img src="@/image/noinfo.png" alt="" /></div>
    <div class="fs20 ftcB4" style="padding: 20px 0">暂无数据</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.noImg {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>


// WEBPACK FOOTER //
// src/components/noInfo.vue